// 9fbef606107a605d69c0edbcd8029e5d
const PRIMARY_FONTS = 'Montserrat';
const SECONDARY_FONTS = 'Nunito';

export const FONTS = {
  primary: PRIMARY_FONTS,
  secondary: SECONDARY_FONTS,
};

// Fonts in android read font file name
export const ANDROID_FONTS = {
  primary: 'montserrat',
  secondary: 'nunito',
};

export const LETTER_SPACINGS = {
  ls222: '2.22px',
  ls167: '1.67px',
  ls317: '3.17px',
  ls4: '4px',
  ls1: '1px',
  ls2: '2px',
  ls071: '0.71px',
  normal: 'normal',
  ls038: '0.38px',
  ls064: '0.64px',
  ls05: '0.5px',
  ls02: '0.2px',
};

export const LINE_HEIGHTS = {
  normal: 'normal',
  lh115: '1.15',
  lh107: '1.07',
  lh1: '1',
  lh125: '1.25',
};

export const TEXT_ALIGNS = { left: 'left', center: 'center', right: 'right' };

export const FONT_WEIGHTS = {
  light: '300',
  regular: '400',
  medium: '500',
  semibold: '600',
  demiBold: '600',
  bold: '700',
  extrabold: '800',
  black: '900',
};

export const FONT_WEIGHT_NAMES = {
  regular: 'Regular',
  medium: 'Medium',
  semibold: 'SemiBold',
  semiBold: 'SemiBold',
  extrabold: 'ExtraBold',
  bold: 'Bold',
  black: 'Black',
  light: 'Light',
  demiBold: 'DemiBold',
};

export const FONT_SIZES = {
  fs64: '64px',
  fs48: '48px',
  fs42: '42px',
  fs40: '40px',
  fs38: '38px',
  fs36: '36px',
  fs32: '32px',
  fs28: '28px',
  fs30: '30px',
  fs26: '26px',
  fs24: '24px',
  fs22: '22px',
  fs21: '21px',
  fs20: '20px',
  fs18: '18px',
  fs16: '16px',
  fs14: '14px',
  fs15: '15px',
  fs13: '13px',
  fs12: '12px',
  fs11: '11px',
  fs10: '10px',
  fs9: '9px',
  fs8: '8px',
  fs6: '6px',
};
